export function evaluateFormula(formula: string, vars: Record<string, number>): number | null {
  const cleaned = formula.replace(/\s+/g, '');
  if (!/^[a-zA-Z0-9+\-*/().]+$/.test(cleaned)) {
    return null;
  }

  let pos = 0;

  function parseExpression(): number {
    let val = parseTerm();
    while (pos < cleaned.length) {
      const op = cleaned[pos];
      if (op !== '+' && op !== '-') {
        break;
      }
      pos++;
      const right = parseTerm();
      if (op === '+') {
        val += right;
      }
      else {
        val -= right;
      }
    }

    // workaround for JS floating precision
    return Math.round(val * 100) / 100;
  }

  function parseTerm(): number {
    let val = parseFactor();
    while (pos < cleaned.length) {
      const op = cleaned[pos];
      if (op !== '*' && op !== '/') {
        break;
      }
      pos++;
      const right = parseFactor();
      if (op === '*') {
        val *= right;
      }
      else {
        if (right === 0) {
          throw new Error('division by zero');
        }
        val /= right;
      }
    }
    return val;
  }

  function parseFactor(): number {
    const ch = cleaned[pos];
    if (ch === '(') {
      pos++;
      const val = parseExpression();
      if (cleaned[pos] !== ')') {
        throw new Error('mismatched parentheses');
      }
      pos++;
      return val;
    }
    if (ch === '-' || ch === '+') {
      const sign = ch === '-' ? -1 : 1;
      pos++;
      return sign * parseFactor();
    }
    return parseNumberOrVariable();
  }

  function parseNumberOrVariable(): number {
    const start = pos;
    while (pos < cleaned.length && /[a-zA-Z0-9]/.test(cleaned.charAt(pos))) {
      pos++;
    }
    const token = cleaned.slice(start, pos);
    if (!token) {
      throw new Error('expected number or variable');
    }

    if (/^\d+(\.\d+)?$/.test(token)) {
      return Number(token);
    }

    if (token in vars) {
      const result = vars[token];
      if (result !== undefined) {
        return result;
      }
    }

    throw new Error(`undefined variable: ${token}`);
  }

  try {
    const result = parseExpression();
    if (pos !== cleaned.length) {
      throw new Error('extra characters after expression');
    }
    return result;
  }
  catch {
    return null;
  }
}
